<template>
  <div class="page-content">
    <!-- 顶部 top -->
    <!-- <div class="tap-title">
      <span>用户管理</span>
    </div> -->

    <!-- 角色搜索以及添加栏目 -->
    <el-row  class="product-menu" type="flex">
      <el-col :span="4">
         <el-button type="primary" class="first-btn" @click="addUser" v-has="'user_add'">添加用户</el-button>
      </el-col>
      <el-row  type="flex" justify="end">
        <el-col :span="12" style="margin-right:20px">
          <el-input placeholder="请输入用户名" v-model.trim="userName" class="input-with-select" >
            <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
          </el-input>
        </el-col>
        <el-col :span="12">
          <el-input placeholder="请输入姓名" v-model.trim="realName" class="input-with-select" >
            <el-button slot="append" icon="el-icon-search" @click="selRel"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="regName"
          label="用户名">
        </el-table-column>
        <el-table-column
         prop="realName"
          label="姓名">
        </el-table-column>
        <el-table-column
         prop="gender"
          label="性别">
        </el-table-column>
        <el-table-column
         prop="phone"
          label="电话">
        </el-table-column>
        <el-table-column
         prop="email"
          label="邮箱">
        </el-table-column>
        <el-table-column
         prop="roleName"
          label="角色">
        </el-table-column>
        <el-table-column
         prop="organizationName"
         align="center"
         label="所属组织">
        </el-table-column>
        <el-table-column
         prop="online"
         align="center"
          label="用户状态">
        </el-table-column>
        <el-table-column
         prop="userAccStatus"
         align="center"
          label="账户状态">
        </el-table-column>
        <el-table-column
        width="300px"
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <span class="check" @click="handlerClick('check',scope.row)" v-has="'user_view'">查看</span>
              <span class="edit" @click="handlerClick('edit',scope.row)" v-has="'user_edit'">编辑</span>
              <span class="check" @click="handlerClick('assign',scope.row)" v-has="'user_bindRole'">分配角色</span>
              <span class="stop" @click="handlerClick('stop',scope.row)" v-has="'user_statusChange'">{{scope.row.userAccStatus==='已启用'?'禁用':'启用'}}</span>
              <span class="del" v-if="scope.row.delete===false" @click="handlerClick('delete',scope.row)" v-has="'user_delete'">删除</span>
              <span class="del" v-else>已删</span>
              <div class="reset" @click="handlerClick('reset',scope.row)" v-has="'user_reset'">重置密码</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog"/>
    <!-- 编辑用户dialog -->
    <editDialog v-if="editDialogVisible" :editDialogVisible="editDialogVisible" :editData="editData" @closeEditDialog="closeEditDialog" :status="status"/>
    <!-- 分配用户dialog -->
    <assignRoleDialog v-if="assignDialogVisible" :assignDialogVisible="assignDialogVisible" :userId="userId" @closeAssignDialog="closeAssignDialog"/>
  </div>
</template>

<script>
import paging from '@/components/paging'
import addDialog from '@/components/userManager/addUserDialog'
import editDialog from '@/components/userManager/editUserDialog'
import assignRoleDialog from '@/components/userManager/assignRoleDialog'
import { userList, deleteUser, userStatus, userReset } from '@/api/user'
export default {
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      userName: '',
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      // viewDialogVisible: false,
      // viewData: null,
      editDialogVisible: false, // 编辑或者查看
      editData: null,
      status: false,
      assignDialogVisible: false, // 分配角色
      userId: '',
      realName: ''
    }
  },
  components: {
    addDialog,
    editDialog,
    assignRoleDialog,
    paging
  },
  created () {
    this.getUserList()
  },
  methods: {
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      // 状态列字体颜色
      if (row.online === '在线' && columnIndex === 7) {
        return 'color: #0CB618'
      } else if (row.online === '离线' && columnIndex === 7) {
        return 'color: #EA1B29'
      } else if (row.userAccStatus === '已启用' && columnIndex === 8) {
        return 'color: #0CB618'
      } else if (row.userAccStatus === '已禁用' && columnIndex === 8) {
        return 'color: #EA1B29'
      } else {
        return 'text-align:center'
      }
    },
    sel () {
      this.listQuery.page = 1
      this.getUserList()
    },
    selRel () {
      this.listQuery.page = 1
      this.getUserList()
    },
    getUserList () {
      const params = {
        regName: this.userName,
        realName: this.realName,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      userList(params).then((res) => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.list
        this.tableData.forEach((item) => {
          if (item.online === true) {
            item.online = '在线'
          } else {
            item.online = '离线'
          }
          if (item.userAccStatus === true) {
            item.userAccStatus = '已启用'
          } else {
            item.userAccStatus = '已禁用'
          }
        })
      })
    },
    addUser () {
      this.addDialogVisible = true
    },
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        this.getUserList()
      }
    },
    closeEditDialog (val) {
      this.editDialogVisible = false
      if (val) {
        this.getUserList()
      }
    },
    closeAssignDialog (val) {
      this.assignDialogVisible = false
      if (val) {
        this.getUserList()
      }
    },
    handlerClick (sty, row) {
      let text
      row.userAccStatus === '已启用' ? text = '禁用' : text = '启用'
      switch (sty) {
        case 'check':
          this.editDialogVisible = true
          this.status = true
          this.editData = Object.assign({}, row)
          break
        case 'edit':
          this.editDialogVisible = true
          this.status = false
          this.editData = Object.assign({}, row)
          break
        case 'assign':
          this.assignDialogVisible = true
          this.userId = row.userId
          break
        case 'stop':

          this.$confirm(`正在${text}当前帐号, 是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const id = row.userId
            userStatus(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: res.data.message
                })
                this.getUserList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已退出'
            })
          })
          break
        case 'delete':
          this.$confirm('确定删除此记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const id = row.userId
            deleteUser(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getUserList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        case 'reset':
          console.log(row.regName)
          this.$confirm('正在重置当前帐号密码, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'alert'
          }).then(() => {
            const id = row.userId
            userReset(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '重置成功'
                })
                if (row.regName === localStorage.getItem('userName')) {
                  setTimeout(() => {
                    this.$router.push('/login')
                  }, 500)
                }
                this.getUserList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        default:
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getUserList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        white-space: nowrap;
        .check,.edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        .reset{
         color:#E6A23C;
          cursor: pointer;
        }
        span{
          margin-left: 15px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
